import { useToast } from '@medely/ui-kit';
import { useNetworkRequest } from '@mp/hooks/useNetworkRequest';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import omit from 'lodash/omit';

export type WorkGapFormValuesProps = {
  start_date: string;
  end_date: string;
  explanation: string;
  id?: number;
};

type WorkGapMutationsProps = {
  values: WorkGapFormValuesProps;
  assignment_request_id?: number | null;
};

export const useWorkGapMutations = () => {
  const { axios } = useNetworkRequest();
  const toast = useToast();
  const queryClient = useQueryClient();

  const { mutate: addWorkGap, isLoading: isAddLoading } = useMutation(
    ({ values, assignment_request_id }: WorkGapMutationsProps) =>
      axios.post('/v3/professional/work_gaps', {
        assignment_request_id,
        work_gap: values,
      }),
    {
      onSuccess: () => {
        toast.success('Work gap added!');
        queryClient.invalidateQueries(['GetWorkGapsForResumeBuilder']);
      },
      onError: () => {
        toast.error('We had an issue, please try again.');
      },
    },
  );

  const { mutate: editWorkGap, isLoading: isEditLoading } = useMutation(
    ({ values, assignment_request_id }: WorkGapMutationsProps) =>
      axios.put(`/v3/professional/work_gaps/${values.id}`, {
        assignment_request_id,
        work_gap: omit(values, ['id', 'state', 'isWorkGap']),
      }),
    {
      onSuccess: () => {
        toast.success('Work gap updated!');
        queryClient.invalidateQueries(['GetWorkGapsForResumeBuilder']);
      },
      onError: () => {
        toast.error('We had an issue, please try again.');
      },
    },
  );

  return { addWorkGap, editWorkGap, isLoading: isAddLoading || isEditLoading };
};
